<div class="pos-panel">
    <div class="pos-new-entity-header">
        <span class="material-icons cyan">trolley</span>
        <span class="soc-panel-h">{{'PURCHASE_ORDER.NEW_PURCHASE_ORDER' | translate }}</span>
    </div>
    <hr class="soc-panel-line" />
    <form #f="ngForm" [formGroup]="form" class="soc-form-wrapper-gap-24" (ngSubmit)="createOrder()">
    <div class="pos-actions-wrapper">
        <div class="soc-dropdown-wrapper" style="text-align: start; flex-direction: row;">
            <!--<div *ngIf="fromInventory" [style.min-width]="'254px'">
                <span class="soc-input-lbl">{{'PURCHASE_ORDER.INVENTORY' | translate }}</span>
                <input [disabled]="true" class="soc-input-field" style="color: var(--soc-neutral-90)"
                    [value]="inventoryDto.name">
            </div>
            <div *ngIf="!fromInventory" [style.min-width]="'254px'">
                <span class="soc-input-lbl">{{'PURCHASE_ORDER.INVENTORY' | translate }}</span>
                <div class="soc-error-field-wrapper">
                    <span *ngIf="form.controls['inventory'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                    <p-dropdown class="soc-dropdown soc-dropdown-search-separator soc-dropdown-btn-separator"
                    [virtualScroll]="true" [filter]="true" [options]="inventories" [(ngModel)]="inventoryDto"
                    optionLabel="name" placeholder="{{'SELECT.INVENTORY' | translate }}"
                    formControlName="inventory"
                    [ngClass]="{'soc-error-active-dropdown': form.controls['inventory'].invalid && f.submitted}"
                    filterPlaceholder="{{'SEARCH' | translate }}">
                    </p-dropdown>
                </div>
            </div> -->
            <div [style.min-width]="'254px'">
               
                <span class="soc-input-lbl">{{'PURCHASE_ORDER.INVENTORY' | translate }}</span>
                <div class="soc-error-field-wrapper">
                    <span *ngIf="!inventoryDto" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                    <input [disabled]="true" class="soc-input-field" style="color: var(--soc-neutral-90)" [ngClass]="{'soc-error-active': !inventoryDto}"
                        [value]="inventoryDto ? inventoryDto.name : ('INVENTORY.NO_MAIN_INVENTORY_SELECTED' | translate)">
                </div>                    
            </div>
            <div *ngIf="fromInventory" [style.min-width]="'254px'">
                <span class="soc-input-lbl">{{'PURCHASE_ORDER.SUPPLIER' | translate }}</span>
                <div class="soc-error-field-wrapper">
                    <span *ngIf="form.controls['supplier'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                    <p-dropdown class="soc-dropdown soc-dropdown-search-separator soc-dropdown-btn-separator"
                        [virtualScroll]="true" [filter]="true" [options]="suppliers" [(ngModel)]="purchaseOrder.supplier"
                        optionLabel="name" placeholder="{{'SELECT.SUPPLIER' | translate }}"
                        formControlName="supplier"
                        [ngClass]="{'soc-error-active-dropdown': form.controls['supplier'].invalid && f.submitted}"
                        filterPlaceholder="{{'SEARCH' | translate }}">
                        <ng-template pTemplate="footer">
                            <div class="footer-wrapper">
                                <button type="button" class="soc-secondary-cyan-btn w-100" (click)="addNewSupplier()"><span
                                        class="material-icons">add</span>{{'PURCHASE_ORDER.NEW_SUPPLIER' | translate }}</button>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>
            <div *ngIf="!fromInventory" [style.min-width]="'254px'">
                <span class="soc-input-lbl">{{'PURCHASE_ORDER.SUPPLIER' | translate }}</span>
                <input [disabled]="true" class="soc-input-field" style="color: var(--soc-neutral-90)"
                    [value]="supplierDto.name">
            </div>
        </div>

        <div class="soc-display-field-wrapper">
            <label class="soc-input-lbl w-100 text-start">{{'PURCHASE_ORDER.ISSUE_DATE' | translate }}</label>
            <div class="soc-display-field"> <span class="soc-display-text">{{todaysDate | tzConvert: timezoneOffset:'DD MMM YYYY'}}</span></div>
        </div>
    </div>
        <p-table class="soc-borderless-table soc-editable-table" [responsive]="true" [value]="orders.controls"
            [scrollable]="true" scrollHeight="calc(100vh - 462px)">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{'INVENTORY_ITEM.CODE' | translate }}</th>
                    <th>{{'INVENTORY_ITEM.ITEM_NAME' | translate }}</th>
                    <th>{{'INVENTORY_ITEM.QUANTITY' | translate }}</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                <ng-container formArrayName="orders">
                    <tr [formGroupName]="rowIndex">
                        <td><input [disabled]="true" class="soc-input-field" style="color: var(--soc-neutral-90)"
                                [value]="orders.value[rowIndex].stockItem ? orders.value[rowIndex].stockItem.code : ''">
                        </td>
                        <td>
                            <div class="soc-error-field-wrapper w-100">
                                <span *ngIf="getOrderControls(rowIndex).controls['stockItem'].invalid && f.submitted"  pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}"  tooltipPosition="top" class="material-icons soc-error-icon" >info</span>
                                <p-dropdown [autoDisplayFirst]="false" formControlName="stockItem" appendTo="body"
                                    class="w-100 soc-dropdown soc-dropdown-search-separator soc-dropdown-btn-separator"
                                    [ngClass]="{'soc-error-active-dropdown': getOrderControls(rowIndex).controls['stockItem'].invalid && f.submitted }" 
                                    [filter]="true" [options]="stockItemsList" optionLabel="name"
                                    placeholder="{{'SELECT.ITEM' | translate }}"
                                    filterPlaceholder="{{'SEARCH' | translate }}">
                                    <ng-template pTemplate="footer">
                                        <div class="footer-wrapper">
                                            <button type="button" class="w-100 soc-secondary-cyan-btn" (click)="addNewInventoryItem()"><span
                                                    class="material-icons">add</span>{{'PURCHASE_ORDER.ADD_NEW_ITEM' | translate }}</button>
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>
                        </td>
                        <td>
                            <div class="soc-addon-input-group soc-error-field-wrapper w-100">
                                <span *ngIf="getOrderControls(rowIndex).controls['quantityOrdered'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                                <div class="p-inputgroup">
                                    <input formControlName="quantityOrdered" class="soc-input-text" type="text"
                                        placeholder="{{'TYPE' | translate}}" pInputText  [ngClass]="{'soc-error-active': getOrderControls(rowIndex).controls['quantityOrdered'].invalid && f.submitted}">
                                    <span class="p-inputgroup-addon soc-input-text"  style="width: 40px !important; "  [ngClass]="{'soc-error-active-addon': getOrderControls(rowIndex).controls['quantityOrdered'].invalid && f.submitted}">{{orders.value[rowIndex].stockItem ?
                                        (orders.value[rowIndex].stockItem.unitType | unitShortener | lowercase) : "-"}}</span>
                                </div>
                            </div>
                        </td>
                        <td class="d-flex justify-content-end"><button type="button" class="soc-secondary-cyan-btn"
                                (click)="onDeleteRow(rowIndex)"><span class="material-icons-round">close</span></button>
                        </td>
                    </tr>
                </ng-container>
            </ng-template>
            <ng-template pTemplate="footer">
                <div class="footer-wrapper">
                    <button type="button" class="soc-secondary-cyan-btn w-100" (click)="addNewRow()"><span
                            class="material-icons">add</span>{{'PURCHASE_ORDER.ADD_ITEM' | translate }}</button>
                </div>
            </ng-template>
        </p-table>
    <hr class="soc-panel-line" />
    <div class="soc-wrapper-gap-12 justify-content-end">
        <button type="button" class="soc-secondary-cyan-btn" (click)="navigateToMain()">{{'CANCEL' | translate }}</button>
        <button [disabled]="orders.length == 0 || inventoryDto == undefined" class="soc-basic-cyan-btn" type="submit">{{'PURCHASE_ORDER.CREATE_ORDER' | translate}}</button>
    </div>
    </form>
</div>
<p-confirmDialog class="soc-confirmation-dialog"></p-confirmDialog>
<p-toast position="top-center"></p-toast>